export const isOtherUserProfileEnabled = false;
// export const isMockStreamInVideoPlayerEnabled = isDevelopmentEnv;
